export const MODULES_TYPES = Object.freeze({
  PRACTICAS: "practicas",
  SKILLS: "skills",
  OTRAS_SKILLS: "otrasSkills",
  CERTIFICACIONES: "certificaciones",
  NIVEL_ESTUDIOS: "nivelEstudios",
  CVS: "cv",
  SUGERENCIAS: "sugerencias",
})